import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.USERS,
  nodeType: Generator.NODETYPE.LIST
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/users/list.js